"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeaturedAppButton_1 = require("./FeaturedAppButton");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return FeaturedAppButton_1.default; } });
